module.exports = __webpack_public_path__ + "img/iphone-13.2c1fcc46.jpg";